module["exports"] = [
  "Nepal"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/nep/address/default_country.js
// module id = 1025
// module chunks = 0